export default __webpack_public_path__ + "static/media/weezaccess-no-icon.ce149cfc.png";